export default {
    showPic(data) {
        return '/lw-garden-personalized-configuration/static/' + data
    }
}